import { Step } from './cerebrum-core';
import { FlowMetaData } from './flow-meta-data';

export class Flow {
  metaData: FlowMetaData;
  steps: Step[];
  flowModeState: any;
  flowEvents: any;
  flowMetaData: any;

  constructor(
    metaData: FlowMetaData,
    steps: Step[]) {
    this.metaData = metaData;
    this.steps = steps;
  }
}
